

import Vue from "vue";
import PriceItemOption from "@/components/account/PriceItemOption.vue";

export default Vue.extend({
	components: {
		PriceItemOption,
	},
	i18nEx: {
		componentPrefix: "components.account"
	},
});

